<template>
  <ConfirmationModal
    cancelText="cancel"
    continueText="create"
    :enableMainAction="enableMainAction"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    headerText="Create New Active Directory Domain"
    :mdTemplate="mdTemplate"
  >
    <InputValidator
      :config="{
        label: 'Domain Name',
        name: inputName,
        validate: 'required|adDomainNameValidation',
        value: domain,
      }"
      @InputValidatorModel="handleValueChange"
    />
  </ConfirmationModal>
</template>
<script>
import * as Constants from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import ActiveDirectoryApi from 'client/api/v2/ActiveDirectoryApi';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import InputValidator from 'components/FormValidation/InputValidator.vue';
import ModalEventBus, { ModalEvents } from 'client/components/Modal/ModalEventBus';
import directoryRouteMixin from 'client/components/mixins/directoryRouteMixin';

const {
  DirectoryNameConsts,
  DirectoryTypeConsts,
  DirectoryTypeKeys,
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;

const storeModule = StoreModuleMap[ItemTypeConsts.directory];

export default {
  name: 'CreateAdDomainModal',

  inject: ['$validator'],

  components: {
    ConfirmationModal,
    InputValidator,
  },

  mixins: [directoryRouteMixin],

  data() {
    return {
      mdTemplate: `This domain name must match the fully qualified domain name as configured in AD. For example: "DC=CONTOSO;DC=Com".
Important: JumpCloud's Active Directory Integration (ADI) supports connectivity between your JumpCloud org and a single AD domain. This AD domain must be a standalone domain that is not a member of an Active Directory Forest and must not have trust relationships to other AD domains. Please see [Getting Started with Active Directory and JumpCloud](https://support.jumpcloud.com/s/article/Getting-Started-Active-Directory-and-JumpCloud) for additional requirements.`,
      domain: '',
      enableMainAction: false,
      inputName: 'Domain Name',
    };
  },

  beforeMount() {
    this.$validator.extend('adDomainNameValidation', {
      getMessage: 'AD domain must match DC=domain name;DC=domain name type',
      validate: value => /^DC=.+;DC=.+/i.test(value),
    });
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),
    ...mapActions(storeModule, ['refreshCollection']),

    handleCancel() {
      ModalEventBus.close();
    },

    handleContinue() {
      const { activeDirectory } = DirectoryTypeKeys;
      const type = DirectoryTypeConsts[activeDirectory];

      ActiveDirectoryApi
        .create({ domain: this.domain })
        .then((item) => {
          ModalEventBus.$once(ModalEvents.transitionEnd, () => {
            this.setLocationHash(this.activeDirectoryDetailsRoute(item.id));
            this.refreshCollection();
          });
          ModalEventBus.close();
        })
        .catch((error) => {
          this.triggerErrorNotification({
            title: `Unable to create ${DirectoryNameConsts[type]}!`,
            message: error && error.message ? error.message : undefined,
          });
        });
    },

    async handleValueChange(value) {
      await this.$validator.validate(this.inputName);
      this.enableMainAction = (this.v2Errors.items.length === 0);

      if (this.enableMainAction) {
        this.domain = value;
      }
    },

    setLocationHash(hash) {
      window.location.hash = hash;
    },
  },
};
</script>
